import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import StarekContext from "../context/StarekContext";
import SearchResults from "../components/modals/SearchResults";
import { gql, useQuery, useMutation } from "@apollo/client";

function Header(props) {
    const { hasLeftMargin = true } = props;
    const GET_USER_ACTIVITIES_QUERY = gql`
        query User($where: UserWhereUniqueInput!) {
            user(where: $where) {
                id
                name
                email
                home_timezone
                show_time_in_home_timezone
                username
                verified
                memberships {
                    role {
                        name
                    }
                }
            }
        }
    `;
    const starekContext = useContext(StarekContext);

    const {
        data: userData,
        loading: userLoading,
        error: userError,
    } = useQuery(GET_USER_ACTIVITIES_QUERY, {
        variables: {
            where: { id: parseInt(starekContext?.user?.id) },
        },
    });

    const [selected, setSelected] = useState(false);
    const [item, setItem] = useState();
    const [timeZones, setTimeZones] = useState();
    const [showModal, setShowModal] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [activities, setActivities] = useState([]);
    const [totalActivity, setTotalActivity] = useState(0);
    const [types, setTypes] = useState([]);
    const [noMore, setNoMore] = useState(true);
    const [page, setPage] = useState(2);

    const toggleSearchModal = (value) => setShowModal(value);

    const handleSwitchWorkspace = () => {
        sessionStorage.setItem(
            "postAuthRedirect",
            window.location.pathname + window.location.search
        );
        navigator("/choose-workspace");
    };

    const navigator = useNavigate();
    return (
        <>
            <nav
                className="main-header navbar navbar-expand navbar-white navbar-light"
                style={{
                    display: "flex",
                    alignItems: "center",
                    height: "73px",
                    borderBottom: "1px solid #e9ecef",
                    marginLeft: hasLeftMargin ? "250px" : "0",
                }}
            >
                {/* Workspace & Plant Section - Flattened */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem",
                        marginLeft: "1.5rem",
                    }}
                >
                    {/* Workspace Logo & Name */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            cursor: "pointer",
                        }}
                        onClick={handleSwitchWorkspace}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.opacity = "0.7";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.opacity = "1";
                        }}
                    >
                        {starekContext?.lastUsedWorkspace?.logo && (
                            <div
                                style={{
                                    borderRadius: "0.5rem",
                                    overflow: "hidden",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src={starekContext?.lastUsedWorkspace?.logo}
                                    alt="Workspace Logo"
                                    style={{
                                        height: "50px",
                                        width: "auto",
                                        maxWidth: "140px",
                                        opacity: 0.9,
                                        objectFit: "contain",
                                    }}
                                />
                            </div>
                        )}
                        <span
                            style={{
                                fontSize: "1rem",
                                color: "#374151",
                                fontWeight: "600",
                            }}
                        >
                            {starekContext?.lastUsedWorkspace?.name}
                        </span>
                    </div>
                </div>

                <ul className="navbar-nav ml-auto">
                    {/* User Profile & Logout Section */}
                    <li className="nav-item" style={{ marginRight: "1rem" }}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.5rem",
                                height: "100%",
                            }}
                        >
                            {/* User Profile Button */}
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.75rem",
                                    cursor: "pointer",
                                    height: "100%",
                                }}
                                onClick={() => {
                                    setSelected(true);
                                }}
                            >
                                <div
                                    style={{
                                        position: "relative",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "36px",
                                        height: "36px",
                                        borderRadius: "50%",
                                        background:
                                            "linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)",
                                        flexShrink: 0,
                                    }}
                                >
                                    <i
                                        style={{
                                            color: "white",
                                            fontSize: "1rem",
                                        }}
                                        className="fa fa-user"
                                    ></i>
                                    {totalActivity > 0 && (
                                        <span
                                            style={{
                                                position: "absolute",
                                                top: "-5px",
                                                right: "-5px",
                                                background: "#dc3545",
                                                color: "white",
                                                borderRadius: "50%",
                                                width: "20px",
                                                height: "20px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "0.75rem",
                                                fontWeight: "600",
                                                border: "2px solid white",
                                            }}
                                        >
                                            {totalActivity}
                                        </span>
                                    )}
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: "0.85rem",
                                            fontWeight: "500",
                                            color: "#333",
                                            lineHeight: "1.2",
                                        }}
                                    >
                                        {starekContext.user?.name || "User"}
                                    </span>
                                </div>
                            </div>

                            {/* Logout Button */}
                            <span
                                className="nav-link"
                                role="button"
                                onClick={async () => {
                                    await starekContext.logout();
                                }}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    paddingLeft: "0",
                                    paddingRight: "0",
                                    height: "100%",
                                    margin: "0",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "36px",
                                        height: "36px",
                                        borderRadius: "50%",
                                        background:
                                            "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                                        flexShrink: 0,
                                    }}
                                >
                                    <i
                                        style={{
                                            color: "white",
                                            fontSize: "1rem",
                                        }}
                                        className="fa fa-sign-out-alt"
                                    ></i>
                                </div>
                            </span>
                        </div>
                    </li>
                </ul>
            </nav>
            {selected && (
                <div
                    role="dialog"
                    aria-modal="true"
                    className="fade modal show"
                    tabIndex={-1}
                    style={{ display: "block" }}
                >
                    <div
                        className="modal-dialog-centered"
                        style={{ width: "50%", margin: "auto" }}
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="modal-title h4">
                                    <h3>User Profile</h3>
                                </div>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => {
                                        setSelected(false);
                                    }}
                                >
                                    <i className="fa fa-times nav-icon"></i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <section className="content">
                                    <div className="form-group">
                                        <label>Home Time Zone</label>
                                        <select
                                            className="form-control"
                                            id="homeTimeZoneId"
                                            name="homeTimeZoneId"
                                            value={
                                                item.home_timezone
                                                    ? item.home_timezone
                                                    : ""
                                            }
                                            onChange={(e) => {
                                                setItem({
                                                    ...item,
                                                    home_timezone:
                                                        e.target.value,
                                                });
                                            }}
                                        >
                                            <option value="0">
                                                --Select--
                                            </option>
                                            {timeZones.map((s, i) => (
                                                <option key={i} value={s}>
                                                    {s}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Always Use Home Timezone</label>
                                        <input
                                            type="checkbox"
                                            className="ml-3"
                                            id="show_time_in_home_timezone"
                                            name="show_time_in_home_timezone"
                                            checked={
                                                item.show_time_in_home_timezone
                                            }
                                            onChange={(e) => {
                                                setItem({
                                                    ...item,
                                                    show_time_in_home_timezone:
                                                        !item.show_time_in_home_timezone,
                                                });
                                            }}
                                        ></input>
                                        <br />
                                        <small>
                                            checking this box will override
                                            browser time zone - not recommended
                                        </small>
                                    </div>
                                </section>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-sm btn-info btn-primary pull-left"
                                    onClick={async () => {
                                        /** TODO; use gql query here */
                                    }}
                                >
                                    Update
                                </button>{" "}
                                <button
                                    className="btn btn-sm btn-info pull-left"
                                    onClick={() => {
                                        setSelected(false);
                                    }}
                                >
                                    Close
                                </button>{" "}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showModal && (
                <SearchResults
                    visibility={showModal}
                    initialSearchText={searchText}
                    setVisibility={toggleSearchModal}
                    setInitialSearchText={setSearchText}
                />
            )}
        </>
    );
}

export default Header;
